export default __webpack_public_path__ + "static/media/Brainstorm.1438ce67.webp";